var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a4 4 0 110 8 4 4 0 010-8zm0 1.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm0 8c1.384 0 3.305.451 4.846 1.163C18.784 15.558 20 16.768 20 18.25A1.75 1.75 0 0118.25 20H5.75A1.75 1.75 0 014 18.25c0-1.482 1.216-2.692 3.154-3.587C8.694 13.95 10.616 13.5 12 13.5zm0 1.5c-1.172 0-2.882.408-4.217 1.025-1.562.722-2.283 1.513-2.283 2.225 0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25c0-.712-.72-1.503-2.283-2.225C14.882 15.408 13.172 15 12 15z"
  })));
}

export default SvgUser;